module.exports = "<div class=\"loadingMessage alert alert-info\" *ngIf=\"!showLoadMessage\">\r\n\t<i class=\"fa fa-spinner fa-pulse\"></i> {{message}}\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/global/_directives/loading-message/loading-message.component.html
// module id = ./src/app/global/_directives/loading-message/loading-message.component.html
// module chunks = 0